module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAATklEQVQ4y83UwQkAIAwDwIADdKSu7kgOUIgtKOgETR7F8xWECj5ZaNbEjffL4lwpiIQzJITBrJVDQNUM3yv1KUtlQkJWB5IKEtppnb9uA9sIuDfug9XVAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA4KzA5OjAwEILqywAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00339_100x100.png
// module id = w8tT
// module chunks = 0